import moment from "../../moment/moment";

import history from "../../history";

import * as routes from "../../routes";
import { getRoundTime } from "../../helpers";
import * as uiConsts from '../../constants/ui';


// TODO: improve selectedDay and Timeline, do not repeat same lines of code, NEED REFACTOR
export const OPEN_RESERVATION_MODAL = "OPEN_RESERVATION_MODAL";
export const CLOSE_RESERVATION_MODAL = "CLOSE_RESERVATION_MODAL";

export const OPEN_TABLE_EXPLORER_MODAL = "OPEN_TABLE_EXPLORER_MODAL";
export const CLOSE_TABLE_EXPLORER_MODAL = "CLOSE_TABLE_EXPLORER_MODAL";

export const OPEN_TABLE_SELECTION_MODAL = "OPEN_TABLE_SELECTION_MODAL";
export const CLOSE_TABLE_SELECTION_MODAL = "CLOSE_TABLE_SELECTION_MODAL";

export const OPEN_TABLE_MODAL = "OPEN_TABLE_MODAL";
export const CLOSE_TABLE_MODAL = "CLOSE_TABLE_MODAL";

export const OPEN_TABLELINK_MODAL = "OPEN_TABLELINK_MODAL";
export const CLOSE_TABLELINK_MODAL = "CLOSE_TABLELINK_MODAL";

export const OPEN_TABLELINK_VIEW_MODAL = "OPEN_TABLELINK_VIEW_MODAL";
export const CLOSE_TABLELINK_VIEW_MODAL = "CLOSE_TABLELINK_VIEW_MODAL";

export const OPEN_ARTEFACT_MODAL = "OPEN_ARTEFACT_MODAL";
export const CLOSE_ARTEFACT_MODAL = "CLOSE_ARTEFACT_MODAL";

export const OPEN_ZONE_MODAL = "OPEN_ZONE_MODAL";
export const CLOSE_ZONE_MODAL = "CLOSE_ZONE_MODAL";

export const OPEN_CUSTOMER_MODAL = "OPEN_CUSTOMER_MODAL";
export const CLOSE_CUSTOMER_MODAL = "CLOSE_CUSTOMER_MODAL";

export const OPEN_BARESTHOFEEDBACK_MODAL = "OPEN_BARESTHOFEEDBACK_MODAL";
export const CLOSE_BARESTHOFEEDBACK_MODAL = "CLOSE_BARESTHOFEEDBACK_MODAL";

export const OPEN_CUSTOMER_FILE_MODAL = "OPEN_CUSTOMER_FILE_MODAL";
export const CLOSE_CUSTOMER_FILE_MODAL = "CLOSE_CUSTOMER_FILE_MODAL";

export const OPEN_CUSTOMER_PROFILE_MODAL = "OPEN_CUSTOMER_PROFILE_MODAL";
export const CLOSE_CUSTOMER_PROFILE_MODAL = "CLOSE_CUSTOMER_PROFILE_MODAL";

export const OPEN_CUSTOMER_DUPLICATES_MODAL = "OPEN_CUSTOMER_DUPLICATES_MODAL";
export const CLOSE_CUSTOMER_DUPLICATES_MODAL = "CLOSE_CUSTOMER_DUPLICATES_MODAL";

export const OPEN_CALENDAR_MODAL = "OPEN_CALENDAR_MODAL";
export const CLOSE_CALENDAR_MODAL = "CLOSE_CALENDAR_MODAL";

export const OPEN_SEARCH_RESERVATION_MODAL = "OPEN_SEARCH_RESERVATION_MODAL";
export const CLOSE_SEARCH_RESERVATION_MODAL = "CLOSE_SEARCH_RESERVATION_MODAL";

export const OPEN_NOTIFICATION_TAB = "OPEN_NOTIFICATION_TAB";
export const CLOSE_NOTIFICATION_TAB = "CLOSE_NOTIFICATION_TAB";

export const OPEN_TABLE_SUMMARY = "OPEN_TABLE_SUMMARY";
export const CLOSE_TABLE_SUMMARY = "CLOSE_TABLE_SUMMARY";

export const UPDATE_SELECTED_DATE = "UPDATE_SELECTED_DATE";
export const UPDATE_STUB_SELECTED_DATE = "UPDATE_STUB_SELECTED_DATE";
export const SET_ACTIVE_RESERVATION = "SET_ACTIVE_RESERVATION";

export const UPDATE_SELECTED_TIME = "UPDATE_SELECTED_TIME";
export const INIT_SELECTED_TIME = "INIT_SELECTED_TIME";

export const SYNC_SELECTED_TIME = "SYNC_SELECTED_TIME";
export const UNSYNC_SELECTED_TIME = "UNSYNC_SELECTED_TIME";

export const OPEN_MEMO_VIEW = "OPEN_MEMO_VIEW";
export const CLOSE_MEMO_VIEW = "CLOSE_MEMO_VIEW";
export const TOGGLE_MEMO_VIEW = "TOGGLE_MEMO_VIEW";

const getTimelineFromSelectedDay = (selectedDay) => {
    const startTime = selectedDay.clone().add(9, 'hour');
    const endTime = selectedDay.clone().add(24, 'hour');
    return {startTime: startTime, endTime: endTime};
};

export const updateSelectedDate = (date, timeline = undefined) => {
    return (dispatch, getState) => {
        const selectedDay = moment(date).startOf('day');
        const today = moment().startOf('day');
        timeline = timeline ?? getTimelineFromSelectedDay(selectedDay);

        const isSync = getState().uiReducer.syncedTime;

        if(!selectedDay.isSame(today) && isSync) {
            dispatch({type: UNSYNC_SELECTED_TIME});
        }

        dispatch({
            type: UPDATE_SELECTED_DATE,
            timeline,
            selectedDay,
        });
    }
};

export const updateStubSelectedDate = (date) => {
    return (dispatch, getState) => {
        const stubSelectedDay = moment(date).startOf('day');

        dispatch({
            type: UPDATE_STUB_SELECTED_DATE,
            stubSelectedDay,
        });
    }
};

export const updateTimeline = (startTime, endTime) => {
    return (dispatch, getState) => {
        const selectedDay = moment((startTime + endTime) / 2).startOf('day');
        const timeline = {startTime: moment(startTime), endTime: moment(endTime)};
        dispatch(updateSelectedDate(selectedDay, timeline));
    };
};

export const onNextDay = () => {
    return (dispatch, getState) => {
        const currentDay = getState().uiReducer.selectedDay;
        const selectedDay = currentDay.clone().add(1, 'day').startOf('day');
        const timeline = getTimelineFromSelectedDay(selectedDay);
        dispatch(updateSelectedDate(selectedDay, timeline));
    }
};

export const onPreviousDay = () => {
    return (dispatch, getState) => {
        const currentDay = getState().uiReducer.selectedDay;
        const selectedDay = currentDay.clone().add(-1, 'day').startOf('day');
        const timeline = getTimelineFromSelectedDay(selectedDay);
        dispatch(updateSelectedDate(selectedDay, timeline));
    }
};

export const updateSelectedTime = (hours, minutes, add=false, useSlice=false) => {
    return (dispatch, getState) => {
        let newTime = add? moment(getState().uiReducer.selectedTime, uiConsts.TIME_FORMAT) : moment();
        const now = moment();

        now.seconds(0).milliseconds(0);
        newTime.seconds(0).milliseconds(0);

        if(add) 
            newTime.add(hours ?? 0, 'hours').add(minutes ?? 0, 'minutes');
            
        else {
            if(hours || hours === 0)
                newTime.set('hours', hours);
            if(minutes || minutes === 0)
                newTime.set('minutes', minutes);
        }

        if(useSlice){
            getRoundTime(newTime, uiConsts.TIME_SLICE);
            getRoundTime(now, uiConsts.TIME_SLICE);
        }

        const isSync = getState().uiReducer.syncedTime;

        if(!newTime.isSame(now) && isSync) {
            dispatch({type: UNSYNC_SELECTED_TIME});
        }
        
        dispatch(
            {
                type: UPDATE_SELECTED_TIME,
                newTime: newTime.format(uiConsts.TIME_FORMAT),
            }
        );
    };
}

export const updateToNow = () => {
    return (dispatch) => {
        dispatch(updateSelectedTime(undefined, undefined, false, true));
        dispatch(updateSelectedDate(moment()));
        dispatch({type: SYNC_SELECTED_TIME});
    };
}

export const updateSelectedTimeFromString = (input) => {
    return (dispatch) => {
        const inputMoment = moment(input);
        dispatch(updateSelectedTime(inputMoment.hours(), inputMoment.minutes()));
    }
}

export const openTableExplorerModal = (date=moment().toDate()) => {
    return {
        type: OPEN_TABLE_EXPLORER_MODAL,
        date: date
    };
};

export const openTableSelectionModal = (date=moment().toDate()) => {
    return {
        type: OPEN_TABLE_SELECTION_MODAL,
        date,
    };
}

export const openCalendarModal = () => {
    history.push(routes.RESERVATIONS);
    return {
        type: OPEN_CALENDAR_MODAL
    };
};

export const openSearchReservationModal = () => {
    history.push(routes.RESERVATIONS);
    return {
        type: OPEN_SEARCH_RESERVATION_MODAL
    };
};

export const setOverReservation = (activeReservation = 0) => {
    return {
        type: SET_ACTIVE_RESERVATION,
        activeReservation,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/ui.js